import { useAssetDetailsContext } from "@/pages/asset-details/context/assetDetailsContext";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import type { EditableCallbackParams } from "ag-grid-community";
import { useNavigate } from "react-router-dom";

const useStyles = makeStyles((theme) =>
	createStyles({
		assetLink: {
			color: theme.palette.primary.main,
			cursor: "pointer",
			textDecoration: "none",
			"&:hover": {
				textDecoration: "underline",
			},
		},
	}),
);

type Props = EditableCallbackParams;

const getCompactPath = (fullPath: string) => {
	if (!fullPath) return "";
	const parts = fullPath.split("/");
	if (parts.length <= 3) return fullPath;
	return `${parts[0]}/.../${parts[parts.length - 2]}/${parts[parts.length - 1]}`;
};

export const AttachmentAssetNameColumn = ({ data }: Props) => {
	const classes = useStyles();
	const navigate = useNavigate();
	const {
		state: { currentGridName, assetSearchId },
	} = useAssetDetailsContext();

	const handleAssetClick = (assetId: string | number) => {
		navigate(
			`/asset-details/${assetId}?resource=${currentGridName}&assets=true&statistics=true&workOrders=true`,
		);
	};

	if (data?.AssetId) {
		const compactPath = getCompactPath(data?.FullPath || "");
		const isCurrentAsset =
			data.AssetId.toString() === assetSearchId?.toString();

		if (isCurrentAsset) {
			return <div title={data?.FullPath}>{compactPath || data?.AssetName}</div>;
		} else {
			return (
				<div
					title={data?.FullPath}
					className={classes.assetLink}
					onClick={() => handleAssetClick(data.AssetId)}
				>
					{compactPath || data?.AssetName}
				</div>
			);
		}
	} else {
		return <div title={data?.FullPath}>{data?.AssetName}</div>;
	}
};
